// src/modules/auth/AdminRoute.js
// Wraps ProtectedRoute (auth + employee lockdown) and additionally requires the
// 'admin' role. Non-admin authenticated users (role 'user') are sent to the
// dashboard; employees are already redirected to /my-time by ProtectedRoute.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  return (
    <ProtectedRoute>
      {user?.role === 'admin' ? children : <Navigate to="/dashboard" replace />}
    </ProtectedRoute>
  );
};

export default AdminRoute;
